import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/AppModule';
import { environment } from './environments/environment';
import { msalInstance } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}).catch(err => {
  console.error('MSAL initialization or redirect handling failed:', err);
});
                             